export default __webpack_public_path__ + "static/media/news4.c114d472.png";